import React from 'react'
import { useAuthRedirect } from '../../../../hooks/use-auth-redirect'
import { AppHeaderLoginBtn } from '../../app-header-login-btn/app-header-login-btn'
import { useAppHeaderRightMenuStyles } from '../app-header-right-menu.styles'

export const MenuForNotAuthenticated: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderRightMenuStyles()
  const { handleLoginRedirect } = useAuthRedirect()

  return (
    <>
      <div
        onClick={() => handleLoginRedirect('/')}
        className={classes.loginBtnWrapper}
      >
        <AppHeaderLoginBtn />
      </div>
    </>
  )
}
